"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DocumentIcon_1 = require("../Icons/DocumentIcon");
var PdfIcon_1 = require("../Icons/PdfIcon");
/**
 * Map of known file information (icon and display name).
 */
var FILE_MAP = {
    pdf: {
        icon: PdfIcon_1.default,
        name: 'PDF'
    }
};
/**
 * Returns the file type information for the input string. If the input
 * string is a media type the file suffix will be extracted and used
 * as the file type.
 *
 * The input string will be returned uppercase as the name if it is not
 * known within the file information map.
 *
 * @param input the file type (extension) or media type string
 */
exports.getFileInfo = function (input) {
    if (input === void 0) { input = ''; }
    // type "/" [tree "."] subtype ["+" suffix] *[";" parameter]
    var mediaTypeRegexp = /[^\/]+\/([^+]*\+)?([^;]+)(;.*)?/g;
    var match = mediaTypeRegexp.exec(input);
    var fileSuffix;
    if (match) {
        fileSuffix = match[2];
    }
    else {
        fileSuffix = input;
    }
    return (FILE_MAP[fileSuffix.toLowerCase()] || {
        icon: DocumentIcon_1.default,
        // use the input as the file name if the input string is not a media type
        // e.g. the generic media type 'application/octet-stream' cannot be mapped
        // on a file type, and therefore shouldn't be set here as the file type
        name: match ? undefined : fileSuffix.toUpperCase()
    });
};
exports.default = exports.getFileInfo;
//# sourceMappingURL=fileInfo.js.map
